import saas from '@/utils/saas'
import request from '@/utils/request'

import { createRequest, createDownRequest, createUploadRequest } from '@/utils/common' // 工具类

const url = saas.Constant.GATEWAY_URL
const service = 'crossborder-merchant-api'

// 查询列表
export function querySetInfoList(data) {
  const api = 'MER_CROSSBORDER_OVERSEAS_PAYEE_QUERY'
  data = saas.data(service, api, data)
  return request({
    url: url + '/' + service + '/api/' + api,
    method: 'post',
    headers: saas.header(data),
    data
  })
}
// 查询列表
export function querySetInfoPage(data) {
  const api = 'MER_CROSSBORDER_OVERSEAS_PAYEE_SELECT'
  data = saas.data(service, api, data)
  return request({
    url: url + '/' + service + '/api/' + api,
    method: 'post',
    headers: saas.header(data),
    data
  })
}

/* 详情 */
export function confirmInfo(data) {
  const api = 'MER_CROSSBORDER_OVERSEAS_PAYEE_SELECTONE'
  data = saas.data(service, api, data)
  return request({
    url: url + '/' + service + '/api/' + api,
    method: 'post',
    headers: saas.header(data),
    data
  })
}
/* 根据itemcode查询字典信息 */
export function queryItemCode(data) {
  const api = 'DIC_ITEM_CODE_QUERY'
  data = saas.data(service, api, data)
  return request({
    url: url + '/' + service + '/api/' + api,
    method: 'post',
    headers: saas.header(data),
    data
  })
}
export function insertData(data) {
  const api = 'MER_CROSSBORDER_OVERSEAS_PAYEE_ADD'
  data = saas.data(service, api, data)
  return request({
    url: url + '/' + service + '/api/' + api,
    method: 'post',
    headers: saas.header(data),
    data
  })
}
export function updateData(data) {
  const api = 'MER_CROSSBORDER_OVERSEAS_PAYEE_UPDATE'
  data = saas.data(service, api, data)
  return request({
    url: url + '/' + service + '/api/' + api,
    method: 'post',
    headers: saas.header(data),
    data
  })
}

// 查询商品名录
export function queryGoods(data){
  return createRequest('risk-api', 'CROSS_EXPORT_GOODS_INFO_PAGE_QUERY', data)
}

// 添加商品
export function insertGoods(data){
  return createRequest('risk-api', 'CROSS_EXPORT_GOODS_INFO_ONE_ADD', data)
}

// 修改商品
export function updateGoods(data){
  return createRequest('risk-api', 'CROSS_EXPORT_GOODS_INFO_ONE_UPDATE', data)
}

// 商品模板下载
export function goodsTemplate(data){
  console.log('goodsTemplate', data)
  return createDownRequest('risk-api', 'CROSS_EXPORT_GOODS_TEMPLATE_DOWNLOAD', data)
}

// 商品导入
export function importGoods(data){
  return createUploadRequest('risk-api', 'CROSS_EXPORT_GOODS_INFO_UPLOAD', data)
}

// 商品导出
export function exportGoods(data){
  return createDownRequest('risk-api', 'CROSS_EXPORT_GOODS_INFO_EXCE', data)
}

// 删除商品名录
export function deleteGoods(data){
  return createRequest('risk-api', 'CROSS_EXPORT_GOODS_INFO_ONE_DELETE', data)
}


